import { useContext, useEffect, useState } from 'react'
import { EventosContext } from '../../../Providers/EventosContext/EventosContext'
import { WebSocketContext } from '../../../Providers/WebSocket/WebSocketContext'
import { UserContext } from '../../../Providers/UserContext/UserContex'
import moment from 'moment'
import useStatusEvento from '../../../hook/useStatusEvento'
import { showNotify } from '../../../Utils/Utils'

export default function TratarEventoBl () {
    const { eventoSelecionado, updateEventoSelecionado } = useContext(EventosContext)
    const { addRoute, sendWs } = useContext(WebSocketContext)
    const { user, check } = useContext(UserContext)
    const { mudarStatusEvento } = useStatusEvento()

    const [logsFechamento, setLogsFechamento] = useState([])
    const [hashtags, setHashtags] = useState([])
    const [notificacoes] = useState({
        supervisao: false,
        gerencia: false,
        sindico: false
    })

    const [obsFechamento, setObsFechamento] = useState()
    const [valueHastag, setValueHashtag] = useState(false)

    useEffect(() => {
        setObsFechamento(eventoSelecionado.obs_fechamento)
    }, [eventoSelecionado])

    useEffect(() => {
        addRoute('buscarTodasTags', setAllHashTags)
        sendWs('buscarTodasTags', {})

        addRoute('buscarTodosFechamentos#monitoramentoPage', setAllLogsCadastrados)
        sendWs('buscarTodosFechamentos#monitoramentoPage', {})
    }, [])

    const setAllHashTags = (msg) => {
        if (msg.data.status) {
            setHashtags(msg.data.tags)
        }
    }

    const setAllLogsCadastrados = (msg) => {
        let logs = []
        if (msg.data.status) {
            msg.data.fechamento.map(obj => {
                const { numero, titulo, descricao } = obj
                logs.push({
                    numero,
                    titulo,
                    descricao
                })
            })

            setLogsFechamento(logs)
        }
    }

    const handleChangeHashtag = (event) => {
        const id = eventoSelecionado.id
        const id_hashtag = event.target.value

        updateEventoSelecionado({
            id_hashtag
        })

        if (!id || !event.target.value) {
            return
        }

        sendWs('gravarHashtag', { id, hashtag: id_hashtag })
    }

    /* retorna true caso não haja evento selecionado. ou caso não o objeto 'usuario_tratando' não exista dentro do eventoSelecionado ou caso o usuário que esteja tratando esse evento não seja o usuário logado */
    const trataEventosDisabled = () => {
        if (check && (check.estado_jornada == 4 || check.estado_jornada == 2 || check.estado_jornada == false)) {
            return true
        }
        return (eventoSelecionado.id == 0 || (!eventoSelecionado.usuario_tratando || eventoSelecionado.usuario_tratando.id != user.id) || eventoSelecionado.status != 2)
    }

    const handleClickLogEvento = (info) => {
        if (info && info.descricao) {
            info.descricao = replaceVarsLog(info.descricao)
            let novaObs = (eventoSelecionado.obs_fechamento ? eventoSelecionado.obs_fechamento + `\n` : '') + `${moment().format('HH:mm:ss')}:${info.descricao}`
            updateEventoSelecionado({ obs_fechamento: novaObs })
            sendWs('gravarObservacao', { id: eventoSelecionado.id, observacao: novaObs })
            const obsInput = document.getElementById('input-obs')
            obsInput.focus()
        }
    }

    const handleObsGPT = (msg) => {
        if (msg) {
            let novaObs = `${moment().format('HH:mm:ss')}:${msg}`
            updateEventoSelecionado({ obs_fechamento: novaObs })
            sendWs('gravarObservacao', { id: eventoSelecionado.id, observacao: novaObs })
        }
    }

    const replaceVarsLog = (txt) => {
        /* eslint-disable */
        let keys = [
            { key: '{{operador}}', value: eventoSelecionado?.usuario_tratando?.nome},
            { key: '{{condominio}}', value: eventoSelecionado.condominio},
            { key: '{{auxiliar_evento}}', value: eventoSelecionado?.entrada},
            { key: '{{ramal}}', value: eventoSelecionado?.usuario_tratando?.ramal}
        ]
        
        Object.values(keys).forEach(obj => {
            if (obj.key && txt.indexOf(obj.key) != -1) {
                let regexp = new RegExp(obj.key, 'g')
                let newValue = (obj.value ? obj.value : '')
                txt = txt.replace(regexp, newValue)
            }
        });
        /* eslint-enable */
        return txt
    }

    const gravarObservacao = () => {
        const id = eventoSelecionado.id
        const observacao = obsFechamento
        updateEventoSelecionado({ obs_fechamento: obsFechamento })

        if (!id || (observacao == undefined)) {
            return
        }

        sendWs('gravarObservacao', { id, observacao })
    }

    const handleMudarStatusEvento = (novoStatus) => {
        const idEvento = eventoSelecionado.id
        mudarStatusEvento(idEvento, novoStatus)
    }

    const finalizarEvento = () => {
        const id = eventoSelecionado.id

        if (!id) {
            return
        }

        if (global.obrigatorio_tag_oini && eventoSelecionado.evento == 'OINI' && eventoSelecionado.usuario_tratando.id == user.id && eventoSelecionado.id_hashtag == 0) {
            showNotify('warning', 'É necesario escolher uma Tag de Atendimento!')
            setValueHashtag(true)
            setTimeout(() => {
                setValueHashtag(false)
            }, 3000)
            return
        } else {
            setValueHashtag(false)
        }
        const observacao = eventoSelecionado.obs_fechamento
        const id_hashtag = eventoSelecionado.id_hashtag
        sendWs('finalizarEvento', { id, observacao, id_hashtag, notificacoes })
    }

    const disabledButtons = (button) => {
        if (check && (check.estado_jornada == 4 || check.estado_jornada == 2 || check.estado_jornada == false)) {
            return true
        }
        if (eventoSelecionado.status == 2 && (!eventoSelecionado.usuario_tratando || eventoSelecionado.usuario_tratando.id != user.id)) {
            return true
        }

        if (eventoSelecionado.id == '') {
            return true
        }

        if (button == "espera") {
            if (eventoSelecionado.status == 3) {
                return true
            } else {
                return false
            }
        } else if (button == "obs") {
            if (eventoSelecionado.status == 4) {
                return true
            } else {
                return false
            }
        }
    }

    return {
        eventoSelecionado,
        hashtags,
        updateEventoSelecionado,
        logsFechamento,
        handleChangeHashtag,
        trataEventosDisabled,
        handleClickLogEvento,
        gravarObservacao,
        handleMudarStatusEvento,
        disabledButtons,
        finalizarEvento,
        obsFechamento,
        setObsFechamento,
        handleObsGPT,
        setValueHashtag,
        valueHastag
    }
}
